import React from "react";
import PropTypes from "prop-types";

export function MenuLayout({ children }) {
  return (
    <div
      data-test="hub-menu"
      style={{
        width: "calc(100vw - 40px - 0.5em)",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "nowrap",
        height: "50px",
        paddingLeft: "1em",
      }}
    >
      {children}
    </div>
  );
}

MenuLayout.propTypes = {
  children: PropTypes.node,
};

MenuLayout.defaultProps = {
  children: null,
};

export default MenuLayout;
